// extracted by mini-css-extract-plugin
module.exports = {"container":"SponsoredBadge_container__KcG2f","content":"SponsoredBadge_content__szRV7"};